import { z } from 'zod'
import {
  normalizeIdentity,
  formalIdentityShape,
} from '../common/identity-schema.js'

export const createCoooriAdminSchema = z
  .object({
    email: z.string().trim().email('Enter a valid email address.'),
    ...formalIdentityShape,
  })
  .transform(normalizeIdentity)

export type CreateCoooriAdminForm = z.infer<typeof createCoooriAdminSchema>

export const editCoooriAdminSchema = z.object(formalIdentityShape).transform(normalizeIdentity)
export type EditCoooriAdminForm = z.infer<typeof editCoooriAdminSchema>
